import Store from "./store"

export default class Components {
    constructor(ref) {
        this.ref = ref
    }

    store() {
        return new Store(this.ref)
    }
}